export default __webpack_public_path__ + "static/media/66-min.6f0bbca0.jpg";